var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useState } from 'react';
import { useRouteChange } from '../_utils/hooks';
import { createPrefixCls } from '../_utils/string';
import Button from '../button';
import Icon from '../icon';
import Modal from './modal';
const prefixCls = createPrefixCls('info');
export const Info = (_a) => {
    var { title, content, okText = '我知道了', onOk, onClose, onUnMount } = _a, restProps = __rest(_a, ["title", "content", "okText", "onOk", "onClose", "onUnMount"]);
    const [visible, setVisible] = useState(true);
    useRouteChange(() => {
        setVisible(false);
    });
    const handleOk = useCallback(() => {
        setVisible(false);
        onOk && onOk();
    }, [onOk]);
    const handleCancel = useCallback(() => {
        setVisible(false);
        onClose && onClose();
    }, [onClose]);
    const handleClose = useCallback(() => {
        setVisible(false);
        onClose && onClose();
        onUnMount && onUnMount();
    }, [onClose, onUnMount]);
    return (React.createElement(Modal, Object.assign({}, restProps, { visible: visible, center: true, onClose: handleClose }),
        React.createElement("div", { className: prefixCls() },
            React.createElement("div", { className: prefixCls('header') },
                React.createElement("div", { className: prefixCls('title') }, title),
                React.createElement("div", { className: prefixCls('close'), onClick: handleCancel },
                    React.createElement(Icon, { className: prefixCls('close-icon'), name: "close" }))),
            React.createElement("div", { className: prefixCls('content') }, React.isValidElement(content) ? content : React.createElement("div", { className: prefixCls('content-text') }, content)),
            React.createElement("div", { className: prefixCls('footer') },
                React.createElement(Button, { className: prefixCls('btn'), onClick: handleOk }, okText)))));
};
export default Info;
